/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.BuyingRpc
 */

/**
 *  Request model for purchasing products and quantity packs.
 *  <p><b>Products:</b> Use {@code products} for parent/bundle products (e.g., "marketing-hub-starter").
 *  <p><b>Quantity Packs:</b> Use {@code quantityPacks} with {@link RequestedQuantity}
 *  <pre>{@code
 *  PurchaseRequest request = PurchaseRequest.builder()
 *    .setQuantityPacks(ImmutableSet.of(
 *      RequestedQuantity.builder()
 *        .setQuantityName(WireSafeEnum.of(QuantityName.CONTACTS))
 *        .setTotalQuantity(10)
 *        .setParentProductApiName("marketing-hub-starter")
 *        .build()
 *    ))
 *    .build();
 *  }</pre>
 */

export let ComHubspotBuyingModelsRpcAbstractBuyingRpcError;
(function (_ComHubspotBuyingModelsRpcAbstractBuyingRpcError) {})(ComHubspotBuyingModelsRpcAbstractBuyingRpcError || (ComHubspotBuyingModelsRpcAbstractBuyingRpcError = {}));
export let ComHubspotBuyingModelsRpcAbstractGetPurchaseError;
(function (_ComHubspotBuyingModelsRpcAbstractGetPurchaseError) {})(ComHubspotBuyingModelsRpcAbstractGetPurchaseError || (ComHubspotBuyingModelsRpcAbstractGetPurchaseError = {}));
export let ComHubspotBuyingModelsRpcAbstractGetSeatUpdateOptionsError;
(function (_ComHubspotBuyingModelsRpcAbstractGetSeatUpdateOptionsError) {})(ComHubspotBuyingModelsRpcAbstractGetSeatUpdateOptionsError || (ComHubspotBuyingModelsRpcAbstractGetSeatUpdateOptionsError = {}));
export let ComHubspotBuyingModelsRpcAbstractUpdatePurchaseError;
(function (_ComHubspotBuyingModelsRpcAbstractUpdatePurchaseError) {})(ComHubspotBuyingModelsRpcAbstractUpdatePurchaseError || (ComHubspotBuyingModelsRpcAbstractUpdatePurchaseError = {}));
export let ComHubspotBuyingModelsRpcEnums;
(function (_ComHubspotBuyingModelsRpcEnums) {})(ComHubspotBuyingModelsRpcEnums || (ComHubspotBuyingModelsRpcEnums = {}));
/**
 *  Request model for purchasing parent products.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
/**
 *  Request model for purchasing quantity packs.
 *  <p>
 *    Exactly one of incrementalQuantity or skuQuantity must be set.
 *    Prefer using incrementalQuantity for clarity.
 *  </p>
 *  <p>
 *    Use incrementalQuantity to indicate net new copies of the SKU to add in the purchase.
 *    Use skuQuantity to indicate total quantity of the SKU that should be owned post-purchase.
 *  </p>
 */
export const createPurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrder',
  auth: 'app',
  fingerprint: '_XCnKSsip0TY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createPurchaseOrderV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'createPurchaseOrderV2',
  auth: 'app',
  fingerprint: 'nCGdwVmW2EjY5pstqgNqILbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsProductInventoryRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsProductInventory',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACHTP33O5UJ5JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePurchaseOrderRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'updatePurchaseOrder',
  auth: 'app',
  fingerprint: 'm0OoPI1YZc1Z3BtbxxkgrECk7omU8k52',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUpgradeRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getUpgrade',
  auth: 'app',
  fingerprint: '53T8GjEfaWN7E6U0LFkMqPlnp7mFMgq9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getQuantityChangeRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getQuantityChange',
  auth: 'app',
  fingerprint: 'Qg3s-HrtHKpKOg7rWeNGx_lnp7mFMgq9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const fetchPostPurchaseProductsRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'fetchPostPurchaseProducts',
  auth: 'app',
  fingerprint: 'ci1sWtYAnpLLGOz8MTmtg_lnp7mFMgq9',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatUpdateOptionsRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatUpdateOptions',
  auth: 'app',
  fingerprint: 'ICa4F7QzY47dPGLTQodufwPX4yvTI74j',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getInterstitial',
  auth: 'app',
  fingerprint: 'nCGdwVmW2Ejy98yoCbO9CLJBp4StIrgH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMarketingContactsInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getMarketingContactsInterstitial',
  auth: 'app',
  fingerprint: 'gzMlFgxr_AMyyFqUjPu4KLJBp4StIrgH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSeatsInterstitialRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'getSeatsInterstitial',
  auth: 'app',
  fingerprint: 'yBZoLGFz-ZFJYm-bGK85ILJBp4StIrgH',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const purchaseAdditionalSeatsRpc = {
  serviceName: 'com.hubspot.buying.rpc.BuyingRpc',
  rpcName: 'purchaseAdditionalSeats',
  auth: 'app',
  fingerprint: 'HFhGk25ey59fXQbgQZW32LbwF4hDbpl5',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};